/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1ClassroomdisciplineWithoutModuleQueryResponse,
  GetApiV1ClassroomdisciplineWithoutModuleQueryParams,
  GetApiV1ClassroomdisciplineWithoutModule400,
  GetApiV1ClassroomdisciplineWithoutModule401,
  GetApiV1ClassroomdisciplineWithoutModule404,
  GetApiV1ClassroomdisciplineWithoutModule500,
} from "../../types/classPlanningController/GetApiV1ClassroomdisciplineWithoutModule.ts";

function getGetApiV1ClassroomdisciplineWithoutModuleUrl() {
  const res = {
    method: "GET",
    url: `/api/v1/classroomdiscipline/without-module` as const,
  };
  return res;
}

/**
 * @description Lista as Aulas (ativas) de uma Disciplina que ainda não estão vinculadas a um Módulo. Os filtros de data (startDate/endDate, por DateStart) são opcionais — cada limite só é aplicado quando informado. **(Requer Authorization para autenticação)**
 * @summary Listar Aulas de uma Disciplina sem Módulo (Requer Authorization para autenticação)
 * {@link /api/v1/classroomdiscipline/without-module}
 */
export async function getApiV1ClassroomdisciplineWithoutModule(
  params?: GetApiV1ClassroomdisciplineWithoutModuleQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1ClassroomdisciplineWithoutModuleQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ClassroomdisciplineWithoutModule400
      | GetApiV1ClassroomdisciplineWithoutModule401
      | GetApiV1ClassroomdisciplineWithoutModule404
      | GetApiV1ClassroomdisciplineWithoutModule500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1ClassroomdisciplineWithoutModuleUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
